"use client";

import React from "react";
import { createPortal } from "react-dom";
import { Toaster as Sonner } from "sonner";

export function Toaster(props) {
  const { style, ...restProps } = props || {}

  const toaster = (
    <Sonner
      theme="system"
      className="toaster group"
      containerAriaLabel="App notifications"
      closeButton
      toastOptions={{
        classNames: {
          toast: "app-sonner-toast",
        },
      }}
      style={{
        ...style,
        "--normal-bg": "var(--popover)",
        "--normal-text": "var(--popover-foreground)",
        "--normal-border": "var(--border)",
        "--border-radius": "var(--radius)",
        zIndex: 2147483647,
      }}
      richColors
      position="top-right"
      {...restProps}
    />
  );

  if (typeof document === "undefined") {
    return toaster;
  }

  return createPortal(toaster, document.body);
}
